<template>

    <div class="col-md-4 mb-3">

        <div class="panel panel-action">

            <div>
                <h6>Pacientes</h6>
                <p>Revisa el registro o crea uno nuevo.</p>
            </div>
            <button type="button" class="btn-pacientes" @click="irPacienteLista">
                Revisar y crear paciente
            </button>
        </div>


        <!-- Esta parte tiene un rol, se debe verificar -->

        <div class="panel">
            <h6 class="panel-title">Filtros del gráfico</h6>
            <div v-if="userRole === 'administrador' || userRole === 'enfermera'" class="field">
                <label>Especialidad</label>
                <select class="form-select form-select-sm" v-model="selectedSeach" @change="onSearchOptionChange">
                    <option value="todos">Todas</option>
                    <option v-for="especialidad in especialidades" :key="especialidad.codigo"
                        :value="especialidad.codigo">
                        {{ especialidad.name }}
                    </option>
                </select>
            </div>
            <div class="field">
                <label>Mes y año</label>
                <VueDatePicker v-model="selectedDate" month-picker locale="es" auto-apply partial-flow
                    :flow="['calendar']" />
            </div>
        </div>






    </div>
    <div class="col-md-8">
        <div class="panel chart-panel">
            <h6 class="panel-title">Atenciones por día</h6>
            <GChart type="ColumnChart" :events="chartEvents" :resizeDebounce="500" :options="options" :data="data" />
        </div>
    </div>


</template>

<script>
/*eslint-disable */
import { GChart } from 'vue-google-charts';
import VueDatePicker from '@vuepic/vue-datepicker';
import moment from 'moment-timezone';


export default {
    name: 'Estadistica',
    components: {
        GChart,
        VueDatePicker
    },
    data() {
        const currentDate = new Date();
        return {
            loading: false,
            isMobile: this.$isMobile,
            especialidades: [],
            selectedSeach: 'todos',
            user: null,
            selectedDate: {
                month: currentDate.getMonth(),
                year: currentDate.getFullYear()
            },
            data: [['Fecha', 'Cantidad']],
            options: {
                width: '100%',
                height: 420,
                title: '',
                legend: { position: 'none' },
                colors: ['#0078be'],
                backgroundColor: 'transparent',
                chartArea: { left: 48, top: 16, width: '90%', height: '78%' },
                bar: { groupWidth: '58%' },
                vAxis: {
                    minValue: 0,
                    textStyle: { color: '#6b7c8f', fontSize: 11 },
                    gridlines: { color: '#eef2f6' }
                },
                hAxis: {
                    textStyle: { color: '#6b7c8f', fontSize: 11 }
                }
            },
            chartEvents: {
                select: () => {
                }
            }
        };
    },
    computed: {
        // Get user role from localStorage
        userRole() {
            const encryptedRole = localStorage.getItem("aut");
            if (encryptedRole && this.$encryptBackoffice && this.$encryptBackoffice.decrypt) {
                return this.$encryptBackoffice.decrypt(encryptedRole);
            }
            return null;
        },
    },

    mounted() {
        if (this.isMobile) {
            this.$eventBus.emit('activeShowMenu');
        }

        const userData = JSON.parse(localStorage.getItem("userData"))
        this.user = userData.email


        this.getEspecialidades();

        // Realizar búsqueda inicial con la opción predeterminada
        this.onSearchOptionChange();
    },

    watch: {
        selectedDate: {
            handler(val) {
                const { month, year } = val;
                if (month !== null && year !== null && this.selectedSeach) {
                    if (this.userRole === 'administrador' || this.userRole === 'enfermera' || this.userRole === 'bodega') {
                        this.getEstadistica(year, month + 1);
                    } else {
                        this.getEstadisticaDoctor(year, month + 1);
                    }
                }
            },
            deep: true
        }
    },

    methods: {
        irPacienteLista() {
            this.$router.push({ name: 'listadoPacientes' });
        },

        async getEstadistica(anio, mes) {
            this.loading = true;
            try {
                const email = this.user

                const resp = await this.$https.post('/estadistica/getLoadGraficos', { anio, mes, selectedSeach: this.selectedSeach, email, role: this.userRole });

                if (resp.data.code === 200) {
                    this.data = [
                        ['Fecha', 'Cantidad'],
                        ...resp.data.datos.map(item => {
                            const formattedDate = moment(item.fecha).tz('America/Guayaquil').format('DD/MM/YYYY');
                            return [formattedDate, item.cantidad];
                        })
                    ];
                } else {
                    this.data = [['Fecha', 'Cantidad'], ['0', 0]];
                    console.error('Sin registros:', resp.data.message);
                }
            } catch (error) {
                console.error('Error al realizar la petición:', error.message);
            } finally {
                this.loading = false;
            }
        },

        onSearchOptionChange() {
            if (this.selectedDate.month !== null && this.selectedDate.year !== null) {
                if (this.userRole === 'administrador' || this.userRole === 'enfermera' || this.userRole === 'bodega') {
                    this.getEstadistica(this.selectedDate.year, this.selectedDate.month + 1);
                } else {
                    this.getEstadisticaDoctor(this.selectedDate.year, this.selectedDate.month + 1);
                }
            }
        },

        async getEspecialidades() {
            try {
                const response = await this.$https.post("/estadistica/getLoadDashboardEspecialidades", {}, { headers: { Authorization: this.tokenAuth } });

                if (response.data.code === 200) {
                    // Filtrar las especialidades que no sean "enfermera" y "administrador"
                    this.especialidades = response.data.datos.filter(especialidad => 
                        especialidad.codigo !== "enfermera" && especialidad.codigo !== "administrador"
                    );
                }
                
            } catch (error) {
                this.loading = false;
                if (error.response.status === 400) {
                    this.showErrorMejor(error.response.data.message);
                }
                if (error.response.status === 401) {
                    this.showSessionExpiredAlert();
                }
            }
        },

        async getEstadisticaDoctor(anio, mes) {
            this.loading = true;
            try {
                const email = this.user

                const resp = await this.$https.post('/estadistica/getLoadGraficoDoctores', { anio, mes, selectedSeach: this.selectedSeach, email });

                if (resp.data.code === 200) {
                    this.data = [
                        ['Fecha', 'Cantidad'],
                        ...resp.data.datos.map(item => {
                            const formattedDate = moment(item.fecha).tz('America/Guayaquil').format('DD/MM/YYYY');
                            return [formattedDate, item.cantidad];
                        })
                    ];
                } else {
                    this.data = [['Fecha', 'Cantidad'], ['0', 0]];
                    console.error('Sin registros:', resp.data.message);
                }
            } catch (error) {
                console.error('Error al realizar la petición:', error.message);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.panel {
    margin-bottom: 12px;
    padding: 16px;
    border: 1px solid #e6edf5;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(15, 35, 52, 0.05);
}

.panel-action {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.panel-icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    display: grid;
    place-items: center;
    background: #fde8f0;
    color: #eb1265;
}

.panel h6,
.panel-title {
    margin: 0 0 4px;
    color: #1f2a37;
    font-size: 0.95rem;
    font-weight: 700;
}

.panel p {
    margin: 0;
    color: #6b7c8f;
    font-size: 0.82rem;
}

.btn-pacientes {
    border: 0;
    border-radius: 10px;
    padding: 10px 14px;
    background: #eb1265;
    color: #fff;
    font-size: 0.85rem;
    font-weight: 700;
}

.btn-pacientes:hover {
    background: #c4125e;
}

.field {
    margin-top: 12px;
}

.field label {
    display: block;
    margin-bottom: 6px;
    color: #6b7c8f;
    font-size: 0.75rem;
    font-weight: 700;
}

.chart-panel {
    min-height: 100%;
}
</style>